<div class="settings" [class.mobile]="deviceService.isMobile()">
  <div class="left">
    <div class="title"> {{'profile-form.microphone.setting-audio-video' | translate}}</div>
    <div class="list-info">{{'profile-form.microphone.possible-solution' | translate}}</div>
    <ol class="list-of-tip">
      <li> {{'profile-form.microphone.reload' | translate}} </li>
      <li> {{'profile-form.microphone.check-your-setting' | translate}}
        <a href="https://support.apple.com/en-am/guide/mac-help/mchlf6d108da/mac" target="_blank" class="link-base">{{'profile-form.microphone.safari-instruction' | translate}}</a>
        <div>
          <app-icon class="video link-base" file="video-record" icon="video-x"></app-icon>
          <app-icon class="mic link-base" file="video-record" icon="microphone-x"></app-icon>
          <app-icon class="lock link-base" file="video-record" icon="lock-x"></app-icon>
        </div>
      </li>
      <li> {{'profile-form.microphone.another-browser' | translate}}
        <a href="https://www.google.com/chrome/" target="_blank" class="link-base">{{'profile-form.microphone.install-chrome' | translate}}</a>
        {{'profile-form.microphone.recommended' | translate}}
      </li>
    </ol>
  </div>
  <div class="right">
    <div class="camera-container">
      <video #video autoplay></video>
    </div>
    <div class="camera-action">
      <label>
        <span class="label">{{'profile-form.microphone.camera' | translate}}</span>
        <app-icon [width]="18" [height]="18" file="video-record" icon="check-circle"></app-icon>
        <on-ui-select
          (changed)="changeVideoInput()"
          [(ngModel)]="settingModel.videosInput"
          [options]="videosInputs">
        </on-ui-select>
      </label>

      <label>
        <span class="label">{{'profile-form.microphone.microphone' | translate}}</span>
        <app-icon [width]="18" [height]="18" file="video-record" icon="check-circle"></app-icon>
        <on-ui-select
          (changed)="changeVideoInput()"
          [(ngModel)]="settingModel.audioOutput"
          [options]="audioInputs">
        </on-ui-select>
      </label>
    </div>
    <div class="mic-volume" #micLevel>
      <span class="active"></span>
      <span class="active"> </span>
      <span class="active"></span>
      <span class="active"></span>
      <span class="active"></span>
      <span class="active"></span>
      <span class="active"></span>
      <span class="active"></span>
      <span class="active"></span>
      <span class="active"></span>
      <span class="active"></span>
      <span class="active"></span>
      <span class="active"></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</div>
